import React from 'react';
import { Col } from 'react-bootstrap';
import { ColSpec } from 'Components/Common/Form/form';

interface Props {
  label: string;
  classForm?: string;
  colMd?: ColSpec;
  classLabel?: string;
}

export const labelRequire = (label: string, classLabel?: string): string | JSX.Element => {
  if (label && label.includes('*')) {
    const title = label.split('*')[0].trim();
    return (
      <span className={`${classLabel}`}>
        {title} <span className="txt-require">*</span>
      </span>
    );
  }
  return <span className={`${classLabel}`}>{label}</span>;
};

export default function FormLable(props: Props): JSX.Element {
  const { label, classForm, colMd, classLabel } = props;

  return (
    <Col md={colMd} className={`${classForm}`}>
      {labelRequire(label, classLabel)}
    </Col>
  );
}
